import { Button } from '@material-tailwind/react';
import AutocompleteDeliveryAddress from './AutocompleteDeliveryAddress';
import React from 'react';
import { pinCodeList } from '../../data/pinCodeData';

const DeliveryAddress = ({
  dropLocation,
  handleDilveryModal,
  setDropLocation,
  deliveryAddresses
}) => {
  const deliveryFields = [
    { key: 'companyName', label: 'Company Name', type: 'text', placeholder: 'Company name', className: 'md:col-span-2 2xl:col-span-2' },
    { key: 'consignee', label: 'Consignee Name', type: 'text', placeholder: 'Consignee name', className: 'md:col-span-2 2xl:col-span-1' },
    { key: 'phone', label: 'Contact No', type: 'number', placeholder: 'Phone number', className: 'md:col-span-2 2xl:col-span-1' },
    { key: 'address', label: 'Address', type: 'text', placeholder: 'Full delivery address', className: 'md:col-span-2 2xl:col-span-4' },
    { key: 'zip', label: 'Pincode', type: 'text', placeholder: 'Pincode', className: '2xl:col-span-1' },
    { key: 'city', label: 'City', type: 'text', placeholder: 'City', className: '2xl:col-span-1' },
    { key: 'region', label: 'State', type: 'text', placeholder: 'State', className: 'md:col-span-2 2xl:col-span-2' },
  ];

  const getCityandState = (pin) => {
    pinCodeList.forEach((zip) => {
      if (zip.Pin === Number(pin)) {
        setDropLocation((prev) => ({
          ...prev,
          city: zip.FacilityCity,
          region: zip.FacilityState,
          zip: pin,
        }));
      }
    });
  };

  const handleClientSelect = (row) => {
    if (!row) return;
    setDropLocation({
      clientId: row.deliveryClientId?.id || row.deliveryClientId || '',
      companyName: row.deliveryCompanyName || '',
      consignee: row.deliveryName || '',
      phone: row.deliveryPhone || '',
      address: row.deliveryAddress || '',
      zip: row.deliveryPincode || '',
      city: row.deliveryCity || '',
      region: row.deliveryState || '',
    });
  };

  return (
    <div className="mt-5 rounded-[28px] border border-slate-200 bg-white px-5 py-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)] lg:px-6">
      <div className="mb-6 flex flex-col gap-3 border-b border-slate-100 pb-5 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className='flex items-center gap-3'>
            <div className='flex h-10 w-10 items-center justify-center rounded-2xl bg-[#dcfce7] text-sm font-[GilroyBold] text-[#15803d]'>03</div>
            <div>
              <h3 className="font-[GilroyBold] text-[1.15rem] text-slate-900">Delivery details</h3>
              <p className='mt-1 text-sm font-[GilroyMedium] text-slate-500'>Select a saved address or enter the consignee details manually.</p>
            </div>
          </div>
        </div>
        <Button onClick={handleDilveryModal} className='rounded-full bg-[#f97316] px-5 py-2.5 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>Add Delivery Address</Button>
      </div>

      <div className='space-y-5'>
        <div className='rounded-[24px] border border-slate-200 bg-slate-50/70 p-5'>
          <div className='flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between'>
            <div>
              <h4 className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Saved address finder</h4>
              <p className='mt-1 text-sm text-slate-500'>Search previous delivery addresses and prefill the consignee block in one click.</p>
            </div>
            <div className='w-full lg:max-w-[420px]'>
              <AutocompleteDeliveryAddress
                data={deliveryAddresses}
                onSelect={handleClientSelect}
                placeholder="Select or search saved client"
              />
            </div>
          </div>
        </div>

        <div className='rounded-[24px] border border-slate-200 bg-[linear-gradient(180deg,_#ffffff,_#f8fafc)] p-5 md:p-6'>
          <div className='mb-5 flex flex-col gap-2 border-b border-slate-100 pb-4'>
            <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Manual delivery details</p>
            <p className='text-sm text-slate-500'>Fill the consignee information below when you are not using a saved address.</p>
          </div>
          <div className="grid gap-5 md:grid-cols-2 2xl:grid-cols-4">
            {deliveryFields.map((field) => (
              <label key={field.key} className={`block ${field.className}`}>
                <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>
                  {field.label}
                </span>
                <input
                  type={field.type}
                  value={dropLocation[field.key] || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDropLocation({ ...dropLocation, [field.key]: value });
                    if (field.key === 'zip') {
                      getCityandState(value);
                    }
                  }}
                  placeholder={field.placeholder}
                  className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                />
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddress;
